import { render, staticRenderFns } from "./SMSFields.vue?vue&type=template&id=939f2c6e"
import script from "./SMSFields.vue?vue&type=script&lang=ts"
export * from "./SMSFields.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports